import React from 'react';
import ReportButton from '../../../components/report/ReportButton';
import * as XLSX from 'xlsx';
import { useCompanyContext } from '../../../context/CompanyContext';
import { useWatch } from 'react-hook-form';
import { BASE_PDF_STYLES } from '../../../../utils/reportUtils';
import { excelCleanTable } from '../../../../utils/excelUtils';
import { POLICY_STATUS, PolicyFiltersOptions } from './PolicyFilters';

type PolicyReportProps = {
  elementRef: React.MutableRefObject<HTMLElement | null>;
};

const PolicyReport = ({ elementRef }: PolicyReportProps) => {
  const { selectedCompany } = useCompanyContext();
  const filters = useWatch<PolicyFiltersOptions>();
  const reportDate = new Date();

  const excelElementPreProcess = (element: HTMLElement) => {
    excelCleanTable(element);

    return element;
  };

  const excelBeforeDownload = (workBook: XLSX.WorkBook) => {
    const sheet = workBook.Sheets['Sheet1'];
    const companyName = selectedCompany!.name;

    sheet['D2'] = { t: 's', v: companyName };
    sheet['D3'] = { t: 's', v: 'Policy Report' };
    sheet['A4'] = { t: 's', v: 'Search criteria:' };
    sheet['B5'] = { t: 's', v: 'Status:' };
    sheet['C5'] = {
      t: 's',
      v: POLICY_STATUS.find((status) => status.value === filters.policyStatus)
        ?.label,
    };

    const rowStart = 6;
    sheet[`A${rowStart}`] = { t: 's', v: 'Created at:' };
    sheet[`B${rowStart}`] = { t: 's', v: reportDate.toLocaleString() };
  };

  return (
    <ReportButton
      elementToPrintRef={elementRef}
      fileName="Policy_Report"
      pdfStyles={BASE_PDF_STYLES}
      excelPreprocess={excelElementPreProcess}
      excelBeforeDownload={excelBeforeDownload}
      tableOriginCell="A8"
      widthElementID="policy-table"
    />
  );
};

export default PolicyReport;
